import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const steps = [
  {
    num: 1,
    title: "Ro'yxatdan o'ting",
    desc: "Telefon raqamingiz orqali bir daqiqada ro'yxatdan o'ting va ilovaga kiring.",
  },
  {
    num: 2,
    title: 'Loyiha tanlang',
    desc: "Filtrlar yordamida o'zingizga mos loyiha va kvartirani tanlang. 3D ko'rinishda ko'ring.",
  },
  {
    num: 3,
    title: 'Bron qiling',
    desc: "Yoqqan kvartira'ni bron qiling. Boshqa xaridorlar sizdan oldin ololmaydi.",
  },
  {
    num: 4,
    title: 'Shartnoma imzolang',
    desc: "Onlayn shartnoma tuzing. Barcha hujjatlar raqamli formatda saqlanadi.",
  },
  {
    num: 5,
    title: "Uyga ko'ching!",
    desc: "Qurilish tugagach kalitni oling va yangi uyingizga ko'ching. Tabriklaymiz!",
  },
];

const HowItWorks = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <section className="hiw-section section-container" id="how-it-works" ref={ref}>
      <div className="hiw-header">
        <span className="section-tag">Bosqichlar</span>
        <h2 className="section-title">
          Qanday <span className="gold-text">ishlaydi?</span>
        </h2>
        <p className="section-desc">
          OSTONA orqali uy sotib olish jarayoni juda oddiy — atigi 5 bosqich.
        </p>
      </div>

      <div className="hiw-timeline">
        <div className="hiw-line" />
        {steps.map((step, i) => (
          <motion.div
            className="hiw-step"
            key={i}
            initial={{ opacity: 0, x: i % 2 === 0 ? -40 : 40 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.5, delay: i * 0.12, ease: 'easeOut' }}
          >
            <div className="hiw-step-content">
              <h3>{step.title}</h3>
              <p>{step.desc}</p>
            </div>
            <div className="hiw-step-dot">{step.num}</div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default HowItWorks;
